export const companySettingKeys = {
  nodeAlias: "NODE_ALIAS",
  nodeTableColumns: "NODE_TABLE_COLUMNS",
};

export const getDefaultMapSettingSlidervalues = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 24, 36, 48,
];
